import React from "react";
import ReactHtmlParser from "react-html-parser";
import ButtonComp from "./ButtonComp";
import { useNavigate } from "react-router-dom";

// ================= ATOMS =================
const StatsItem = ({ value, highlight, label, index }) => (
  <div className="text-center px-1 px-sm-2 px-md-3 stats-item-responsive">
    {([1, 0].includes(index) || highlight === "+" || highlight === "%") ? (
      <div className="hero-title fw-800 FS48">
        {value}
        <span className="symbol-text-success">{highlight}</span>
      </div>
    ) : (
      <div className="hero-title fw-800 FS48">
        <span className="symbol-text-success">{highlight}</span>
        {value}
      </div>
    )}
    <div className="FS20FW500 text-gray-pricing plus-sans mt-1">{label}</div>
  </div>
);

// ================= MOLECULE =================
const ProfileCard = ({ profile  }) => (
  <div className="profile-wrap position-relative">
    <div className={`${profile?.image.includes("Varun-sir-hero.webp") ? 'profile-card' : ''} border-0`}>
      <div className="card-body text-white p-3 p-sm-4">
        <div className="position-relative mb-3">
          <img
            src={profile?.image}
            alt={profile?.name || "PTE trainer profile photo"}
            className="img-fluid rounded-4 w-100 profile-img"
            style={
              profile?.imageSize != null
                ? { "--image-scale": profile.imageSize }
                : undefined
            }
          />
        </div>

        {profile?.stats?.length > 0 &&
          <div className="d-flex justify-content-between text-center pt-2 gap-1 gap-sm-2 flex-xl-nowrap flex-wrap">
            {profile?.stats.map((s, i) => (
              <div key={i} className="stats-blur-box flex-grow-1">
                <div
                  className="fw-800 FS32 text-success hero-title mb-0"
                  style={{ fontStyle: "unset" }}
                >
                  {s.value}
                </div>
                <span
                  className="FS12 fw-400"
                  style={{ color: "rgba(255, 255, 255, 0.45)" }}
                >
                  {s.label}
                </span>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  </div>
);

// ================= ORGANISM =================
const HeroSectionUpdated = ({ data , isTrustedShow = true }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // First preference → custom action (popup, modal etc.)
    if (data.btn_outline.onClick) {
      data.btn_outline.onClick();
      return;
    }

    // Route navigation
    if (data.btn_outline.link) {
      navigate(data.btn_outline.link);
    }
  };
  return (
    <section className="new-updated-hero-section position-relative">
      <div className="hero-section text-white position-relative overflow-hidden">
        <div className="hero-bg" />

        <div className="custom-container position-relative z-2 py-3 py-sm-4 py-md-5 mt-5 px-4 px-xxl-0">
          <div className="row align-items-center g-3 g-md-4">
            {/* LEFT */}
            <div className="col-12 col-lg-7 mb-4 mb-lg-0">
              <span className="students-stat mb-2 mb-sm-3 d-inline-block">{data.badge}</span>

              {data.title && data.title()}

              <p
                className="mb-5 FS20FW500 fw-400"
                style={{ color: "rgba(222, 222, 222, 1)" }}
              >
                {data.subtitle && ReactHtmlParser(data.subtitle)}
              </p>

              <div className="d-flex flex-column flex-xl-row gap-2 gap-sm-3 mb-5">
                {data.btn_prepration && (
                  <ButtonComp
                    link={data.btn_prepration.onClick}
                    btnText={data.btn_prepration.text}
                    img="/images/web-new-images/new-dark-arrow.svg"
                  />
                )}

                {data.btn_outline && (
                  <button
                    className="border-btn gap-2 primary-btn w-auto w-sm-auto"
                    onClick={handleClick}
                  >
                    {data.btn_outline.text}
                    <img
                      src={`/images/web-new-images/new-green-arrow.png`}
                      alt="Register Now"
                    />
                  </button>
                )}
              </div>

              {
                isTrustedShow &&
                <div className="d-flex align-content-center justify-content-center justify-content-md-start gap-3">
                  {data.appDownloadBtn && data.appDownloadBtn()}
               <div className="join-community d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-lg-start gap-3 gap-sm-5 gap-md-3">
                <div className="avatars d-flex">
                  {data.users && data.users.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt="user"
                      className="user-img avatar rounded-circle"
                    />
                  ))}
                </div>
                <div className="text-center text-sm-start">
                  <div className="text-center text-sm-start">
                    <div className="d-flex gap-1 gap-sm-2 justify-content-center justify-content-sm-start svg-responsive">
                      {data.users && [...Array(5)].map((_, index) => (
                        <svg
                          key={index}
                          width="17"
                          height="19"
                          viewBox="0 0 17 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="star-icon"
                        >
                          <path
                            d="M8.30801 0L10.2693 6.90983H16.6162L11.4815 11.1803L13.4428 18.0902L8.30801 13.8197L3.17327 18.0902L5.13456 11.1803L-0.00017643 6.90983H6.34671L8.30801 0Z"
                            fill="#F0C522"
                          />
                        </svg>
                      ))}
                    </div>
                    <span className="join-text FS14FW600 fw-500 d-block mt-2">
                      {data.trustText}
                    </span>
                  </div>
                </div>
              
              </div>
              
              
            </div>
}
            {/* RIGHT */}
          </div>
            <div className="col-12 col-lg-4 profile-card-background" style={{'--top-position': data.profile.topSpacing ? data.profile.topSpacing : '-20%'}}>
              <ProfileCard profile={data.profile} />
            </div>
        </div>
      </div>
      
      </div>
      {/* STATS BAR */}
      {data.bottomStats &&
        <div className="stats-bar mt-3 mt-sm-4 mt-md-5 p-2 p-sm-3 p-md-4 d-flex flex-wrap justify-content-between gap-2 gap-sm-3 custom-container">
          {data.bottomStats.map((item, i) => (
            <StatsItem key={i} index={i} {...item} />
          ))}
        </div>
      }
    </section>
  );
};

export default HeroSectionUpdated;
